<!-- 
PopupPreviewModal.vue
功能：彈跳式廣告_預覽畫面
作者：i9400538 陳博承
完成：2021-07-22
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">重要資訊</h3>
        </div>
        <div class="modal-body">
          <div class="image">
            <img :src="imgSrc" alt="預覽圖片" />
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="$emit('close')" class="btn btn-primary">結束預覽</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupPreviewModal",
  watch: {
    open: function(val) {
      if (val) {
        if (this.img) {
          //有傳入檔案名稱 (編輯模式且未異動過圖檔)
          if (
            window.location.href.indexOf("localhost") !== -1 ||
            window.location.href.indexOf("tmycrm") !== -1
          ) {
            this.imgSrc =
              "https://tmycrm.cathaylife.com.tw/CRMDocs/popup_image/" +
              this.img;
          } else if (window.location.href.indexOf("smycrm") !== -1) {
            this.imgSrc =
              "https://smycrm.cathaylife.com.tw/CRMDocs/popup_image/" +
              this.img;
          } else {
            this.imgSrc =
              "https://mycrm.cathaylife.com.tw/CRMDocs/popup_image/" + this.img;
          }
        } else {
          // 新增或編輯模式(有異動過圖檔)
          this.imgSrc = URL.createObjectURL(this.file);
        }
      }
    }
  },
  data() {
    return {
      imgSrc: ""
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
      default: ""
    },
    file: undefined
  }
};
</script>
<style scoped>
.image > img {
  width: 100%;
  height: auto;
}
.modal.fade .modal-body {
  min-height: auto;
}
</style>
